import { NetworkStatus, type QueryResult } from '@apollo/client'
import { useIsFocused } from '@react-navigation/native'
import { useEffect } from 'react'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useRefetchQueryOnFocus<T extends QueryResult<any, any>>(query: T) {
  const isFocused = useIsFocused()
  const { refetch, networkStatus } = query

  const initializing = networkStatus === NetworkStatus.loading

  useEffect(() => {
    if (isFocused && !initializing) void refetch()
  }, [isFocused, refetch, initializing])

  return query
}
